import GlobalSearch from './GlobalSearch'
import UserMenu from './UserMenu'
import { Row } from './pure/FlexContainer'
import { useAuthContext } from '../contexts/AuthContext'
import { useArchiveContext } from '../contexts/ArchiveContext'
import t from '../../tools/t'
import PrimeIcon from './pure/PrimeIcon'

export default function Header() {
    const { isLoggedIn } = useAuthContext()

    return (
        <Row className="header" tag="header" alignment="center" arrangement="end" gap={1} wide>
            {isLoggedIn && (
                <Row gap={1} alignment="center">
                    <HeaderArchiveToggle />
                    <UserMenu />
                </Row>
            )}
            <GlobalSearch />
        </Row>
    )
}

function HeaderArchiveToggle() {
    const { includeArchived, hideArchived } = useArchiveContext()

    if (!includeArchived) return null

    return (
        <Row
            className="header__archive-toggle clickable-text"
            gap={0.25}
            arrangement="center"
            alignment="center"
            onClick={hideArchived}
        >
            <PrimeIcon name="file-excel" size={12} />
            {t('common_hide_archived')}
        </Row>
    )
}
